const UserNotificationTypes = Object.freeze({
  All: 0,
  EmployeeOverspendInternal: 1,
  ScheduleOvercrowdedMeeting: 2,
  ScheduleHighInvestmentMeeting: 3,
  ScheduleRecurringMeeting: 4,
  EmployeeOverspendExternal: 5,
  LowAttendance: 6,
  AIMeetingSimilaritiesRecognition: 7,
  AIPredictions: 8,
});

export default UserNotificationTypes;
